/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_4_WInputs */

const en_cp_cmp_4_w = /** @type {(inputs: Cp_Cmp_4_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The pre-incubation stage: a verified MVP plus a document pack ready for Hacksprint/Bootcamp.`)
};

const id_cp_cmp_4_w = /** @type {(inputs: Cp_Cmp_4_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap pra-inkubasi: MVP terverifikasi + paket dokumen siap dibawa ke tahap Hacksprint/Bootcamp.`)
};

/**
* | output |
* | --- |
* | "The pre-incubation stage: a verified MVP plus a document pack ready for Hacksprint/Bootcamp." |
*
* @param {Cp_Cmp_4_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_4_w = /** @type {((inputs?: Cp_Cmp_4_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_4_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_4_w(inputs)
	return en_cp_cmp_4_w(inputs)
});